// Defensive loading z obsługą błędów
let redirects = [];
try {
  redirects = require('./redirects.json');
  if (!Array.isArray(redirects)) {
    console.error('redirects.json must contain an array');
    redirects = [];
  }
} catch (error) {
  console.error('Failed to load redirects.json:', error);
}

// Optymalizacja: Map zamiast find() dla O(1) lookup
const redirectsMap = new Map(redirects.map((r) => [r.fromPath, r.toPath]));

/**
 * Client-side redirects — wsparcie dla redirectów w trybie developerskim.
 *
 * Zastosowanie:
 * 1. Development only (gatsby develop) — w trybie dev redirecty z gatsby-node.js
 *    nie działają, więc wykonujemy je po stronie klienta jak najwcześniej.
 *
 * Uwaga: To rozwiązanie jest projektowane z myślą o środowisku developerskim,
 * aby skrócić pętlę feedbacku. Nie jest przeznaczone do produkcji.
 */
exports.onClientEntry = () => {
  // Wczesne wyjście jeśli brak przekierowań
  if (redirectsMap.size === 0) return;

  // Normalizuj ścieżkę: usuń trailing slash (chyba że to root /)
  const currentPath = window.location.pathname.replace(/\/$/, '') || '/';

  // O(1) lookup zamiast O(n) find()
  const toPath = redirectsMap.get(currentPath);

  if (toPath) {
    // Walidacja bezpieczeństwa: tylko wewnętrzne przekierowania
    const isSingleLeadingSlash = toPath.startsWith('/') && !toPath.startsWith('//');
    if (!isSingleLeadingSlash) {
      console.error('Invalid redirect target (protocol-relative or external-like):', toPath);
      return;
    }

    try {
      const resolved = new URL(toPath, window.location.origin);
      if (resolved.origin !== window.location.origin) {
        console.error('Invalid redirect target (cross-origin):', toPath);
        return;
      }
    } catch (e) {
      console.error('Invalid redirect target (malformed URL):', toPath, e);
      return;
    }

    // window.location.replace() nie dodaje wpisu do historii - użytkownik nie może "cofnąć" do 404
    window.location.replace(toPath);
  }
};
